import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class ValidateSimCardApi {
  static uri = "a/internet/validateSimCard";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get() {
    return getData({
      uri: ValidateSimCardApi.uri,
      context: this.context,
    });
  }
}
